import React from 'react';
import { FixedTab, RouteTabs } from '../../components/RouteTabs';
import { ITransferContract } from '../../services/types';
import ContractList from './ContractList';

interface IProps {
  onEditClick: (contract: ITransferContract) => void;
  path: string;
}

const ManageContracts = (props: IProps): JSX.Element => {
  const { onEditClick, path } = props;

  const handleEditClick = (contract: ITransferContract) => {
    onEditClick(contract);
  };

  return (
    <RouteTabs path={path} isNested={true}>
      <FixedTab label="All">
        <ContractList onEditClick={handleEditClick} />
      </FixedTab>
      <FixedTab label="To be terminated" uri="tobe">
        <ContractList onEditClick={handleEditClick} isToBeTerminated={true} />
      </FixedTab>
    </RouteTabs>
  );
};

export default ManageContracts;
